module.exports = __webpack_public_path__ + "static/workshops-0a7636727a8af2582d26e8a2acc2a28f.jpg";